/* GRIMSUPPS — Formül hikâyesi + içerik tablosu renderer */
(function () {
  var SERIF = "'Instrument Serif',Georgia,serif";

  function el(tag, style, text) {
    var n = document.createElement(tag);
    if (style) for (var k in style) n.style[k] = style[k];
    if (text != null) n.textContent = text;
    return n;
  }
  function initials(s) { return (s || '').split(' ')[0].slice(0, 3); }

  var SEQ_NOW = '';
  function cropUrl(cr) {
    var m = /\/(\d+)\.png$/.exec(cr.img || '');
    if (!m) return '';
    return (window.STORY_IMG && window.STORY_IMG[m[1]]) || '';
  }
  function cropTile(cr, size, a) {
    var url = cropUrl(cr);
    if (!url) return null;
    var S = 100 / cr.f;
    var X = (cr.x - 0.5 * cr.f) / (1 - cr.f) * 100;
    var Y = (1.25 * cr.y - 0.5 * cr.f) / (1.25 - cr.f) * 100;
    return el('div', {
      width: size + 'px', height: size + 'px', borderRadius: '50%', overflow: 'hidden',
      border: '1px solid ' + a + '44', margin: '0 auto', backgroundColor: '#FFFFFF',
      backgroundImage: 'url(' + url + ')', backgroundSize: S.toFixed(0) + '%',
      backgroundPosition: X.toFixed(1) + '% ' + Y.toFixed(1) + '%',
      boxShadow: '0 2px 10px #24232314'
    });
  }

  function disc(txt, c, big, a) {
    var solid = !!c;
    return el('div', {
      width: big ? '110px' : '86px', height: big ? '110px' : '86px', borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: SERIF, fontSize: big ? '30px' : '22px',
      color: solid ? '#FAFAF9' : a,
      background: solid ? c : a + '14',
      border: solid ? 'none' : '1.5px solid ' + a + '55',
      boxSizing: 'border-box', margin: '0 auto',
      boxShadow: solid ? '0 8px 22px ' + c + '33' : 'none'
    }, solid ? txt : '');
  }

  function tile(o, a) {
    var w = el('div', { textAlign: o.left || o.box ? 'left' : 'center', flex: '0 0 auto', maxWidth: o.max || '210px' });
    if (o.left) { w.style.borderTop = '2px solid ' + a; w.style.paddingTop = '10px'; }
    if (o.box) {
      w.style.borderTop = '3px solid ' + a;
      w.style.background = a + '0A';
      w.style.padding = '16px 18px 18px';
      w.style.minWidth = '190px';
      w.style.maxWidth = o.max || '230px';
    }
    if (o.disc) w.appendChild(o.disc);
    if (o.stat) w.appendChild(el('div', { fontFamily: SERIF, fontSize: o.statSize || '46px', color: o.statColor || a, lineHeight: 1 }, o.stat));
    if (o.t) w.appendChild(el('div', Object.assign({
      fontSize: o.box ? '12px' : '11px', fontWeight: 800, letterSpacing: '0.1em',
      color: o.box ? a : '#242323', marginTop: (o.left || o.box) ? '0' : '10px', lineHeight: 1.35
    }, o.tStyle || {}), o.t));
    if (o.s) w.appendChild(el('div', { fontSize: '12.5px', color: '#242323AB', marginTop: '6px', lineHeight: 1.5 }, o.s));
    return w;
  }

  function joiner(txt, a) {
    return el('div', { fontFamily: SERIF, fontSize: '31px', color: a + '99', flex: '0 0 auto', alignSelf: 'center' }, txt);
  }

  function factsBox(v, a) {
    var rows = v.rows || [], dense = rows.length > 12, cols = '1fr auto 52px';
    var box = el('div', {
      width: '100%', maxWidth: dense ? '520px' : '440px', border: '1px solid #24232318',
      background: '#FDFDFC', padding: dense ? '18px 20px' : '20px 24px', boxSizing: 'border-box'
    });
    if (v.title) box.appendChild(el('div', { fontSize: '11.5px', fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', color: a, paddingBottom: '10px' }, v.title));
    if (v.serving) {
      /* "Servis / Kutuda" notu istenmiyor */
    }
    if (v.unit) {
      var hd = el('div', { display: 'grid', gridTemplateColumns: cols, gap: '12px', fontSize: '10px', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#24232399', borderTop: '2px solid ' + a, paddingTop: '10px', paddingBottom: '6px' });
      hd.appendChild(el('div', null, 'İçindekiler'));
      hd.appendChild(el('div', { textAlign: 'right' }, v.unit));
      hd.appendChild(el('div', { textAlign: 'right' }, '%BRD'));
      box.appendChild(hd);
    }
    rows.forEach(function (r) {
      var tr = el('div', { display: 'grid', gridTemplateColumns: cols, gap: '12px', alignItems: 'baseline', borderTop: '1px solid #24232314', padding: dense ? '6px 0' : '9px 0' });
      tr.appendChild(el('div', { fontSize: dense ? '12.5px' : '13.5px', color: r.sub ? '#242323A0' : '#242323', paddingLeft: r.sub ? '14px' : '0', lineHeight: 1.5 }, r.n));
      tr.appendChild(el('div', { fontSize: dense ? '12.5px' : '13.5px', fontWeight: 800, color: r.sub ? '#242323A0' : a, textAlign: 'right', lineHeight: 1.5 }, r.v));
      tr.appendChild(el('div', { fontSize: '11px', fontWeight: 700, color: '#2423238C', textAlign: 'right' }, r.brd || ''));
      box.appendChild(tr);
    });
    if (v.foot) box.appendChild(el('div', { fontSize: '11px', lineHeight: 1.55, color: '#242323AB', borderTop: '1px solid #24232314', paddingTop: '10px', marginTop: '4px' }, v.foot));
    return box;
  }

  function buildViz(v, a) {
    if (!v) return null;
    var wrap = el('div', { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' });
    var K = v.kind;

    if (K === 'facts') { wrap.appendChild(factsBox(v, a)); return wrap; }

    if (K === 'chelate') {
      var ring = el('div', { position: 'relative', width: '260px', height: '260px', margin: '6px auto 20px', border: '1.5px dashed ' + a + '77', borderRadius: '50%' });
      var c = el('div', { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', width: '92px', height: '92px', borderRadius: '50%', background: a, color: '#FAFAF9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: SERIF, fontSize: '35px', boxShadow: '0 10px 26px ' + a + '44' }, v.center || 'Mg');
      ring.appendChild(c);
      [-90, 0, 90, 180].forEach(function (deg) {
        var r = deg * Math.PI / 180;
        ring.appendChild(el('div', {
          position: 'absolute', left: (130 + 130 * Math.cos(r)) + 'px', top: (130 + 130 * Math.sin(r)) + 'px',
          transform: 'translate(-50%,-50%)', width: '56px', height: '56px', borderRadius: '50%',
          background: '#FFFFFF', border: '1.5px solid ' + a + '88', display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: '10.5px', fontWeight: 800, color: a, boxSizing: 'border-box'
        }, 'A.A.'));
      });
      wrap.appendChild(ring);
      if (v.caption) wrap.appendChild(el('div', { fontSize: '11.5px', fontWeight: 800, letterSpacing: '0.1em', color: '#242323AB', textAlign: 'center', maxWidth: '320px', lineHeight: 1.6 }, v.caption));
      return wrap;
    }

    var row = el('div', { display: 'flex', flexWrap: 'wrap', gap: '22px 26px', alignItems: 'center', justifyContent: 'center' });
    var cells = [];

    if (K === 'stack' || K === 'puzzle') {
      (v.items || []).forEach(function (it) {
        cells.push(tile({ disc: disc('Mg', it.c, true, a), t: it.t, s: it.s }, a));
      });
    } else if (K === 'compare') {
      var mk = function (sd) {
        var im = sd.crop ? cropTile(sd.crop, 150, a) : null;
        return im ? tile({ disc: im, t: sd.title, s: sd.caption }, a) : tile({ box: true, t: sd.title, s: sd.caption }, a);
      };
      cells = [mk(v.a), joiner(v.joiner || 'VS', a), mk(v.b)];
    } else if (K === 'flow') {
      var mkF = function (sd) {
        if (sd.stat) return tile({ stat: sd.stat, t: sd.label, s: sd.sub }, a);
        var im = sd.crop ? cropTile(sd.crop, 140, a) : null;
        return im ? tile({ disc: im, t: sd.label, s: sd.sub }, a) : tile({ box: true, t: sd.label, s: sd.sub }, a);
      };
      cells = [mkF(v.from), joiner('→', a), mkF(v.to)];
    } else if (K === 'path') {
      (v.items || []).forEach(function (it, ix) {
        if (ix) cells.push(joiner('→', a));
        var im = it.crop ? cropTile(it.crop, 130, a) : null;
        cells.push(im ? tile({ disc: im, t: it.t, max: '170px' }, a) : tile({ box: true, t: it.t, max: '160px' }, a));
      });
    } else if (K === 'crop') {
      var im0 = cropTile(v.crop, 250, a);
      if (!im0) {
        if (!v.caption) return null;
        cells = [tile({ t: v.caption, max: '340px', tStyle: { fontSize: '13px', letterSpacing: '0.06em', color: a, lineHeight: 1.6, marginTop: '0' } }, a)];
        row.style.borderLeft = '2px solid ' + a;
        row.style.paddingLeft = '18px';
      } else {
        cells = [tile({ disc: im0, max: '280px' }, a)];
      }
    } else if (K === 'points') {
      if (v.crop) { var imc = cropTile(v.crop, 170, a); if (imc) cells.push(tile({ disc: imc }, a)); }
      (v.items || []).forEach(function (it) {
        var imi = it.crop ? cropTile(it.crop, 110, a) : null;
        cells.push(imi
          ? tile({ disc: imi, t: it.t, s: it.s, max: '170px' }, a)
          : tile({ t: it.t, s: it.s, left: true, max: '190px' }, a));
      });
      if (!v.crop && !(v.items || [])[0].crop) { row.style.justifyContent = 'flex-start'; row.style.gap = '18px 20px'; }
    } else if (K === 'pins') {
      (v.items || []).forEach(function (t) {
        cells.push(el('div', { fontSize: '13.5px', fontWeight: 800, letterSpacing: '0.08em', color: a, border: '1px solid ' + a + '55', padding: '10px 16px', background: a + '0A' }, t));
      });
    } else if (K === 'dial') {
      cells = [tile({ stat: v.value, statSize: '72px', t: v.label, s: v.sub }, a)];
    } else return null;

    if (!cells.length) return null;
    if ((K === 'compare' || K === 'flow') && cells.length === 3 && !cells[0].firstChild.style.borderRadius) {
      row.style.display = 'grid';
      row.style.gridTemplateColumns = 'minmax(0,1fr) auto minmax(0,1fr)';
      row.style.gap = '18px';
      row.style.alignItems = 'center';
      cells[0].style.maxWidth = 'none'; cells[2].style.maxWidth = 'none';
      cells[0].style.minWidth = '0'; cells[2].style.minWidth = '0';
      cells[0].style.justifySelf = 'stretch'; cells[2].style.justifySelf = 'stretch';
    }
    cells.forEach(function (c2) { row.appendChild(c2); });
    wrap.appendChild(row);
    if (K !== 'crop' && v.caption) wrap.appendChild(el('div', { fontSize: '11.5px', fontWeight: 800, letterSpacing: '0.1em', color: '#242323AB', textAlign: 'center', marginTop: '18px', maxWidth: '340px', lineHeight: 1.6 }, v.caption));
    return wrap;
  }

  function scenesFor(seq) {
    if (!window.STORY || !window.STORY_SEQ) return [];
    var key = window.STORY_SEQ[String(seq)] || window.STORY_SEQ[String(parseInt(seq, 10))];
    return (key && window.STORY[key]) || [];
  }

  function renderStory(host) {
    var seq = host.getAttribute('data-seq');
    SEQ_NOW = ('0' + parseInt(seq, 10)).slice(-2);
    var a = host.getAttribute('data-accent') || '#242323';
    var lb = host.getAttribute('data-label') || 'SORU';
    var scenes = scenesFor(seq).filter(function (s) { return !s.viz || s.viz.kind !== 'facts'; });
    if (!scenes.length) { host.closest('[data-story-band]') && (host.closest('[data-story-band]').style.display = 'none'); return; }
    var narrow = window.matchMedia('(max-width:900px)').matches;

    scenes.forEach(function (sc, i) {
      var alt = i % 2 === 1 && !narrow;
      var viz = buildViz(sc.viz, a);
      var solo = !viz;
      var rowEl = el('div', {
        display: 'grid',
        gridTemplateColumns: (narrow || solo) ? '1fr' : '1.05fr 1fr',
        gap: narrow ? '26px' : '56px', alignItems: 'center',
        padding: narrow ? '34px 0 30px' : '46px 0 40px',
        borderTop: i ? '1px solid #24232312' : 'none',
        opacity: '0', transform: 'translateY(26px)',
        transition: 'opacity .65s ease, transform .65s ease'
      });

      var txt = el('div', { order: alt ? '2' : '1', maxWidth: solo ? '820px' : '560px' });
      txt.appendChild(el('div', { fontSize: '11.5px', fontWeight: 800, letterSpacing: '0.14em', color: a }, lb + ' ' + ('0' + (i + 1)).slice(-2)));
      var h = el('h3', { fontFamily: SERIF, fontSize: 'clamp(26px,3.2vw,36px)', lineHeight: 1.12, fontWeight: '400', margin: '10px 0 0', textWrap: 'pretty' }, sc.q);
      txt.appendChild(h);
      txt.appendChild(el('div', { width: '44px', borderTop: '2px solid ' + a, margin: '16px 0 2px' }));
      (sc.paras || []).forEach(function (p) {
        txt.appendChild(el('p', { fontSize: '15.5px', lineHeight: 1.75, color: '#242323C7', margin: '14px 0 0', textWrap: 'pretty' }, p));
      });
      if (sc.note) {
        var nt = el('p', { borderLeft: '3px solid ' + a, background: a + '0D', padding: '14px 18px', marginTop: '20px', fontSize: '15px', lineHeight: 1.65, color: '#242323DD' });
        if (sc.note.lead) nt.appendChild(el('b', { fontWeight: '800', color: a }, sc.note.lead));
        nt.appendChild(document.createTextNode(' ' + (sc.note.text || '')));
        txt.appendChild(nt);
      }
      rowEl.appendChild(txt);
      if (viz) { viz.style.order = alt ? '1' : '2'; rowEl.appendChild(viz); }
      host.appendChild(rowEl);
    });

    reveal(host);
  }

  function renderFacts(host) {
    var seq = host.getAttribute('data-seq');
    var a = host.getAttribute('data-accent') || '#242323';
    var sc = scenesFor(seq).filter(function (s) { return s.viz && s.viz.kind === 'facts'; })[0];
    if (!sc) { var b = host.closest('[data-facts-band]'); if (b) b.style.display = 'none'; return; }
    var v = sc.viz;
    var box = factsBox(Object.assign({}, v, { title: '', serving: '' }), a);
    box.style.maxWidth = '760px';
    box.style.border = 'none';
    box.style.background = 'transparent';
    box.style.padding = '0';
    host.appendChild(box);
  }

  function reveal(host) {
    var kids = Array.prototype.slice.call(host.children);
    if (!('IntersectionObserver' in window)) {
      kids.forEach(function (k) { k.style.opacity = '1'; k.style.transform = 'none'; });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    kids.forEach(function (k) { io.observe(k); });
  }

  function boot() {
    document.querySelectorAll('[data-story-scenes]:not([data-done])').forEach(function (h) { h.setAttribute('data-done', '1'); renderStory(h); });
    document.querySelectorAll('[data-facts-table]:not([data-done])').forEach(function (h) { h.setAttribute('data-done', '1'); renderFacts(h); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
